import React, { Component } from 'react';
import '../../public/css/media/_track.scss';
import { format } from 'date-fns';
import {maskEventRemarks, maskOriginID, netcoreScript} from '../utils/utils';
import OutBoundBanner from './OutBoundBanner';

class Track extends Component {
  state = {
    latest:'',
    latestRemarks:'',
    status:'',
    estimatedDate:'',
    deliveredDate:'',
    trackingNumber: '',
    searchResult: '',
    settings: null,
  }
	componentWillMount(){
		const tracking_number = this.props.params.id;
      if (tracking_number) {
        this.props.getTrackDetails(tracking_number);
        this.setState({trackingNumber: tracking_number})
      }
    }
    
  componentDidMount(){
  // <!-- NetCore Script -->
  const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
  window.smartech && netcoreScript(accountNumber);
  // <!-- NetCore Script -->      
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params.id !== this.props.params.id) {
      this.props.getTrackDetails(this.props.params.id);
      this.setState({ trackingNumber: this.props.params.id })
    }
  }
	// handleTrackPackage() {
	// 	localStorage.setItem("trackPackage", "true");
	// }
  	componentWillReceiveProps(nextProps){
      if (nextProps.shipmentInfo.track){
        this.setState({ searchResult: nextProps.shipmentInfo.track })
        if (nextProps.shipmentInfo.track !== this.props.shipmentInfo.track){
          this.props.getGlobalSettings(nextProps.shipmentInfo.track.shipment && maskOriginID(nextProps.shipmentInfo.track.shipment.toUpperCase().slice(0,2)));
        }
        if (nextProps.settings.globalSettings !== this.props.settings.globalSettings) {
          const { data } = nextProps.settings.globalSettings;
          const settings = data.map(item => item);
          this.setState({ settings });
        }
      }
  	}
  
  componentWillUnmount() {
    this.props.removeTrackDetails()
  }

  	handleStatus(track_status){
  		switch (track_status) {
          case "confirmed":
          case "for_pickup":
          case "consolidated":
          case "for_consolidation":
            return "Preparing for Shipment";
          case "failed_pickup":
          case "in_transit":
          case "out_for_delivery":
          case "failed_delivery":
          case "return_in_transit":
          case "returned":
          case "failed_return":
          case "for_acceptance":
          case "accepted":
          case "received_at_pickup_hub":
          case "received_at_delivery_hub":
          case "for_return":
          case "received_at_delivery_area":
          case "at_sorting_center":
          case "in_transit_to_delivery_area":
          case "transferred_to_partner":
          case "for_transfer":
          case "out_for_return":
          case "for_dropoff":
          case "dropped_off":
          case "dws_update":
            return "On Its Way";
          case "pending":
          case "canceled":
          case "rejected":
            return "Cancelled"
          case "delivered":
          case "claimed":
          case "picked_up":
            return "Delivered";
          default:
            return "";
        }
  	}

  onChange(e) {
    const {value, name} = e.target;
    if (/\s/g.test(value)) return;
    this.setState({ [name]: value })
  }
  
  handleSearchButton(){
    if (!this.state.trackingNumber) return;
    this.props.getTrackDetails(this.state.trackingNumber)
  }

  reverseTrackingEvents (shipment) {
    return shipment.events
      .sort((a, b) => (a.created_at < b.created_at ? 1 : -1))
      .filter(event => {
        if (event.status === 'for_acceptance') return null;
        if (event.status === 'for_transfer') return null;
        if (
          shipment.shipment === 'uk-sea' &&
          event.remarks.toLowerCase().includes('accepted at office')
        )
          return null;
        if (event.status === 'consolidated' && shipment.events.length > 1) return null;
        return event;
      });
  }

  handleKeyDown = (e) => {
    if (!this.state.trackingNumber) return;
    if (e.key === 'Enter') {
      this.props.getTrackDetails(this.state.trackingNumber)
    }
  }

  handleCanceledStatus (status) {
    switch (status) {
      case "canceled":
      case "CANCELED":
      case "cancelled":
      case "CANCELLED":
      case "rejected":
      case "REJECTED":
        return false;
      default:
        return true;
    }
  }


render(){
  const marketingBanners = [
    { key: 1, img: 'https://cdn.shippingcart.com/assets/bfm-main-image-20220819044707.png', title: 'BUY-FOR-ME SERVICE', description: 'Tell us what items you’d like to buy and we’ll make your shopping experience easier.', link: '/buy-for-me-shopping-guide' },
    { key: 2, img: 'https://cdn.shippingcart.com/assets/turbo-boxes-20220719015550.png', title: 'SOCIAL SELLERS', description: 'Want to receive your online orders for your biz from the US, UK, Korea, Japan and Australia quickly and affordably?', link: '/shippingcart-sellers' },
    { key: 3, img: 'https://cdn.shippingcart.com/assets/pasabuyanihan-main-image-1-20220630030011.png', title: 'PASABUYANIHAN', description: 'Lahat ng international orders mo, at nila, kayang kaya sa isang shipping', link: '/pasabuyanihan' },
  ]

  const outBoundBannerData = this.state.settings && this.state.settings.filter(data => data.name === "outbound_banner");

return (
  <div>
  	<div className="page-track">
    	<div id="shippingcart_app" className="header-original">
      	<div className="body-wrapper">
        	<div className="track-header">
          	<h1 className="page-title">Track Your Package</h1>
            <div className='search-wrapper'>
              <div className='search-title'>Enter your ShippingCart tracking number</div>
              <div className="search-input">
                <input type="search" className='search-input-field' value={this.state.trackingNumber} name="trackingNumber" onChange={(e) => this.onChange(e)} placeholder="1234-5678-ABCD" onKeyDown={this.handleKeyDown} />
                <button type="submit" onClick={() => this.handleSearchButton()}>Search</button>
              </div>
            </div>
        	</div>

          <div className='page-body-wrapper'>
            <div className="container page-body" hidden={!this.state.searchResult}>
              {this.props.shipmentInfo.fetchTrackDetail ? <div className="spinner"><i className="fa fa-spinner fa-spin" /></div> :
                this.state.searchResult.shipment && this.handleCanceledStatus(this.state.searchResult.status) ?
                <div style={{marginBottom: '40px'}}>
                  <div className="shipment-history-title">Shipment History</div>
                  {outBoundBannerData && <div style={{margin: '10px 0px'}}>
                    <OutBoundBanner outBoundBannerData={outBoundBannerData} />
                  </div>}
                  <div className='track-list-wrapper'>
                    {this.state.searchResult.events.length > 0 ? this.reverseTrackingEvents(this.state.searchResult).map((event, index) => {
                      return event && event.status !== 'for_transfer' && (
                        <div className='track-list-item'>
                          <div className='track-icon-wrapper'>
                            <i className="fa fa-map-marker" aria-hidden="true" style={index === 0 ? { fontSize: '30px', color: 'rgb(170, 14, 14)' } : { fontSize: '30px' } } />
                            <span className='track-dash-line' />
                          </div>
                          <div className='track-list-content'>
                            <div className='track-remarks'>{maskEventRemarks(event.remarks, event.status_updated_at, event.status)}</div>
                            <div className='track-dates'>{format(event.created_at, 'MM/DD/YYYY hh:mm A')}</div>
                          </div>
                        </div>
                      )}
                    ) : 
                    (
                      <div className='track-list-item' style={{ placeContent: 'center' }}>
                        <div className='track-icon-wrapper'>
                          <i className="fa fa-map-marker" aria-hidden="true" style={{ fontSize: '30px', color: 'rgb(170, 14, 14)' }} />
                          <span className='track-dash-line' />
                        </div>
                        <div className='track-list-content'>
                          <div className='track-remarks'>Your package is being processed for shipping.</div>
                          <div className='track-dates'>{format(this.state.searchResult.transaction_date, 'MM/DD/YYYY hh:mm A')}</div>
                        </div>
                      </div>
                    )
                    }
                    <div className='information-wrapper'>
                      <div className='information-box'>
                        <span className='information-icon' />
                        <div className='information-content'>
                          <div className='information-title'>Frequently Asked Questions</div>
                          <div className='information-description'>For more info visit our <a href="https://help-center.shippingcart.com/hc/en-us" target="_blank" rel="noopener noreferrer">help center</a>.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              :
                <div className="empty-wrapper">
                  <span className="search-empty search-not-found-icon" />
                  <h3 className="search-empty-msg">Tracking details not found!</h3>
                  <h4 className="search-empty-msg2">Check your tracking number and try it again.</h4>
                </div>
              }
            </div>
          </div>
          <div className='marketing-banner'>
            {marketingBanners && marketingBanners.map(banner => 
              <div className='marketing-banner-box' id={banner.key}>
                <div className='banner-image-wrapper'>
                  <img className='banner-image-link' src={banner.img} alt='' />
                </div>
                <div>
                  <div className='track-banner-title'>{banner.title}</div>
                  <p className='track-banner-description'>{banner.description}</p>
                  <a href={banner.link} target="_blank">Learn more</a>
                </div>
              </div>
            )}
          </div>
      	</div>
      </div>
    </div>
  </div>
)}}

export default Track;



/** WEBPACK FOOTER **
 ** ./src/components/Track.js
 **/